import type { AppCopy } from '../catalogs';

export const lvAppCopy = {
  welcomeHeading: 'Kā es varu jums palīdzēt šodien?',
  thinking: 'Domāšana',
  scrollToBottom: 'Ritiniet uz leju',
  reasoning: 'Spriešana',
  reasoningInProgress: 'procesā',
  citationPages: 'Lappuses {first}–{last}',
  citationTitle: 'Avota fragments',
  citationLoading: 'Ielādē avotu…',
  citationUnavailable: 'Citētais teksts nav pieejams vai jums vairs nav piekļuves.',
  citationOpen: 'Atvērt avotu',
  citationCopied: 'Atsauce nokopēta',
  copy: 'Kopēt',
  more: 'Vairāk',
  tryAgain: 'Mēģiniet vēlreiz',
  answerTruncated: 'Atbilde sasniedza garuma ierobežojumu un tika pārtraukta.',
  continueAnswer: 'Turpināt atbildi',
  exportMarkdown: 'Eksportēt kā Markdown',
  edit: 'Rediģēt',
  cancel: 'Atcelt',
  update: 'Atjaunināt',
  previous: 'Iepriekšējais',
  next: 'Tālāk',
  messagePlaceholder: 'Nosūtīt ziņu…',
  projectHomePlaceholder: 'Jauna tērzēšana: {project}',
  sharedChatEveryone: 'Visi uzņēmumā {company} var lasīt šo tērzēšanu',
  sharedChatOnePerson: '1 persona var lasīt šo tērzēšanu',
  sharedChatPeople: '{count} personas var lasīt šo tērzēšanu',
  forkedChatPlaceholder: 'Turpiniet ar saviem savienojumiem…',
  newAnswer: 'Jauna atbilde',
  messageInput: 'Ziņojuma ievade',
  sendMessage: 'Nosūtīt ziņu',
  stopGenerating: 'Beidziet ģenerēt',
  addAttachment: 'Pievienojiet pielikumu',
  removeFile: 'Noņemt failu',
  attachmentPreview: 'Pielikuma priekšskatījums',
  imageAttachmentPreview: 'Attēla pielikuma priekšskatījums',
  image: 'Attēls',
  openLink: 'atvērt saiti',
  document: 'Dokuments',
  file: 'Fails',
  attachment: 'pielikumu',
  uploadFailed: 'augšupielāde neizdevās',
  uploading: 'augšupielāde',
  toolIncomplete: 'Nepabeigts',
  toolActivity: 'Darbība',
  activityThinking: 'Domā…',
  activityWriting: 'Raksta…',
  activityWaiting: 'Gaida jūsu apstiprinājumu',
  activityStopped: 'Apturēts',
  activityCouldNotFinish: 'Neizdevās pabeigt',
  activitySources: 'avoti',
  activityShowThinking: 'Rādīt domāšanu',
  activityOpen: 'Atvērt darbību',
  activitySteps: 'Soļi',
  activitySourcesTab: 'Avoti',
  activityUnavailable: 'Šī darbība nav pieejama.',
  activityInput: 'Ievade',
  activityOutput: 'Izvade',
  activityNoSources: 'Atbilde nesatur avotu citātus.',
  activityApprovedByReply: 'Apstiprināts ar jūsu atbildi',

  toolRunning: 'Darbojas',
  toolComplete: 'Pabeigts',
  toolNeedsApproval: 'Nepieciešams apstiprinājums',
  toolInput: 'Ievade',
  toolCall: 'rīku izsaukums',
  toolCalls: 'rīku zvani',
  openMenu: 'Atvērt izvēlni',
  closeMenu: 'Aizvērt izvēlni',
  close: 'Aizvērt',
  showInTextField: 'Rādīt teksta laukā',
  settings: 'Iestatījumi',
  appearance: 'Izskats',
  themeLight: 'Gaišs',
  themeDark: 'Tumšs',
  themeSystem: 'Sistēma',
  themeChoiceHelp:
    'Attiecas uz visām jūsu ierīcēm. Sistēma seko katras ierīces gaišajam vai tumšajam režīmam.',
  themeSaveFailed: 'Izskatu neizdevās saglabāt, tāpēc tas nav mainīts. Mēģiniet vēlreiz.',
  toolUsed: 'Izmantotais rīks',
  toolCancelled: 'Atcelts rīks',
  toolResult: 'Rezultāts:',
  toolError: 'Kļūda:',
  toolCancelledReason: 'Atcelts iemesls:',
  approvalAllow: 'Atļaut',
  approvalAlwaysAllow: 'Vienmēr atļaut',
  approvalDeny: 'Noraidīt',
  approvalAlwaysDeny: 'Vienmēr noraidīt',
  approvalConfirm: 'Apstiprināt',
  approvalBack: 'Atpakaļ',
  approvalApprovedResult: 'Apstiprinājis lietotājs',
  approvalDeniedResult: 'Lietotājam ir liegta rīka izpilde',
  logout: 'Atteikties',
  loginOrCreateAccount: 'Piesakieties / Izveidojiet kontu',
  newChat: 'Jauna tērzēšana',
  untitledChat: 'Tērzēšana bez nosaukuma',
  previousChats: 'Iepriekšējās tērzēšanas sarunas',
  openChat: 'Atvērt tērzēšanu {title}',
  moreActionsForChat: 'Citas darbības {title}',
  chatActions: 'Tērzēšanas darbības',
  closeChatActions: 'Aizvērt tērzēšanas darbības',
  deleteChatQuestion: 'Vai dzēst tērzēšanu?',
  deleteChatDescription: 'Tērzēšana “{title}” tiks neatgriezeniski izdzēsta.',
  deleteChat: 'Dzēst tērzēšanu',
  keepChat: 'Saglabāt tērzēšanu',
  delete: 'Dzēst',
  deleting: 'Notiek dzēšana…',
  chatDeleteFailed: 'Tērzēšanu nevarēja izdzēst. Mēģiniet vēlreiz.',
  settingsDescription: 'Pielāgojiet, kā palīgs darbojas jūsu labā.',
  settingsDesktopDescription: 'Pielāgojiet, kā palīgs jums atbild.',
  personalization: 'Personalizēšana',
  personalizationDescription: 'Pielāgojiet norādījumus, ko asistents ievēro katrā atbildē.',
  languageAndRegion: 'Valoda un reģions',
  languageAndRegionDescription: 'Izvēlieties valodu un laika joslu.',
  memories: 'Atmiņas',
  memoriesDescription: 'Skatiet, rediģējiet vai dzēsiet to, ko palīgs atceras par jums.',
  account: 'Konts',
  accountDescription: 'Pārvaldiet kontu un neatgriezenisku datu dzēšanu.',
  backToSettings: 'Atgriezties uz iestatījumiem',
  closeSettings: 'Aizveriet iestatījumus',
  settingsCategories: 'Iestatījumu kategorijas',
  yourSettings: 'Jūsu iestatījumi',
  dataAndAccount: 'Dati un konts',
  viewAndManageMemories: 'Skatiet un pārvaldiet, ko palīgs atceras',
  loginToUseMemories: 'Piesakieties, lai izmantotu atmiņas',
  manageOrDeleteAccount: 'Pārvaldiet vai dzēsiet kontu',
  unsavedChanges: 'Jums ir nesaglabātas izmaiņas',
  unsavedCloseDescription: 'Aizverot iestatījumus, šajā lapā veiktās izmaiņas tiks atmestas.',
  unsavedBackDescription: 'Atgriežoties, šajā lapā veiktās izmaiņas tiks atmestas.',
  continueEditing: 'Turpināt rediģēt',
  discardChanges: 'Atmest izmaiņas',
  saveChanges: 'Saglabāt izmaiņas',
  localSettingsNote: 'Saglabāts šajā pārlūkprogrammā. Piesakieties, lai saglabātu savā kontā.',
  personality: 'Personība',
  personalityHelp: 'Pielāgoti norādījumi, ko palīgs ievēro katrā atbildē',
  personalityPlaceholder:
    'Piemēram: esiet kodolīgs un konkrēts. Es dzīvoju Gēteborgā un man patīk veģetārs ēdiens.',
  timezone: 'Laika josla',
  searchTimezone: 'Meklēt laika joslas…',
  automaticBrowser: 'Automātiski (pārlūks)',
  saved: 'Saglabāts {date}',
  addMemory: 'Pievienot atmiņu',
  newMemory: 'Jauna atmiņa',
  memoryPlaceholder: 'Piemēram: es dodu priekšroku īsām, konkrētām atbildēm.',
  editMemory: 'Rediģēt atmiņu',
  saveMemory: 'Saglabāt atmiņu',
  deleteMemory: 'Dzēst atmiņu',
  memorySaveFailed: 'Atmiņu nevarēja saglabāt. Mēģiniet vēlreiz.',
  memoryLimitReached: 'Varat saglabāt līdz 50 atmiņām. Izdzēsiet vienu, pirms pievienojat jaunu.',
  memoryInvalid: 'Atmiņās nedrīkst būt saites. Noņemiet saiti un mēģiniet vēlreiz.',
  memoryDeleteFailed: 'Atmiņu nevarēja izdzēst. Mēģiniet vēlreiz.',
  memoryLoadFailed: 'Atmiņas nevarēja ielādēt.',
  loadingMemories: 'Notiek atmiņu ielāde…',
  emptyMemories:
    'Asistents saglabā atmiņas par jums, kamēr jūs runājat — kas jums patīk, kur dzīvojat un ar ko nodarbojaties. Šeit varat tos skatīt, rediģēt un dzēst.',
  deleteAccountHelp:
    'Neatgriezeniski dzēsiet kontu un visas saistītās tērzēšanas sarunas, atmiņas un iestatījumus.',
  deleteAccount: 'Dzēst kontu',
  deleteAccountQuestion: 'Vai neatgriezeniski dzēst kontu?',
  deleteAccountDescription:
    'Visas tērzēšanas sarunas, ziņojumi, atmiņas, iestatījumi un pierakstīšanās akreditācijas dati tiks dzēsti. Šo darbību nevar atsaukt.',
  deleteAccountConfirm: 'Jā, dzēst manu kontu',
  accountDeleteFailed: 'Kontu nevarēja izdzēst. Nekas netika noņemts — mēģiniet vēlreiz.',
  logoutEverywhereTitle: 'Visas ierīces',
  logoutEverywhereHelp:
    'Atsakieties visās ierīcēs un pārlūkos, kur ir atvērts jūsu konts, arī šajā.',
  logoutEverywhere: 'Atteikties visur',
  logoutEverywhereQuestion: 'Vai atteikties visās ierīcēs?',
  logoutEverywhereDescription:
    'Jums būs jāpiesakās vēlreiz visās ierīcēs un pārlūkos, arī šajā. Jūsu tērzēšanas un iestatījumi paliks nemainīti.',
  loggingOut: 'Notiek atteikšanās…',
  logoutEverywhereFailed:
    'Neizdevās apstiprināt, ka esat atteicies visur. Mēģiniet vēlreiz vai pārbaudiet citā ierīcē, vai joprojām esat pierakstījies.',
  settingsSaveFailed: 'Iestatījumus nevarēja saglabāt. Mēģiniet vēlreiz.',
  customInstructions: 'Pielāgotas instrukcijas',
  notSet: 'Nav iestatīts',
  automaticLanguage: 'Automātiskā valoda',
  automaticTimezone: 'automātiskā laika josla',
  appLanguage: 'Lietotnes valoda',
  appLanguageHelp:
    'Pārvalda visu lietotnes saskarni un datumus. Asistenta atbildes joprojām tiek sniegtas valodā, kurā rakstāt.',
  automaticBrowserLanguage: 'Automātiski (pārlūka valoda)',
  previousLanguageChoice: 'Iepriekšējā izvēle: {language} ({locale})',
  previousLanguageChoiceCode: 'Iepriekšējā izvēle ({locale})',
  canvasCopyLink: 'Kopēt saiti',
  canvasLinkCopied: 'Saite nokopēta',
  actionUpdatedWithEdits: 'Atjaunināts ar jūsu labojumiem',
  activityStepsDone: 'zero:darbību pabeigts|one:darbība pabeigta|other:darbības pabeigtas',
  activityResultsCount: 'zero:rezultātu|one:rezultāts|other:rezultāti',
  canvasCopyLinkFailed: 'Saiti neizdevās nokopēt',
  canvasOpenInAgent: 'Atvērt lietotnē {agent}',
  canvasExpand: 'Izvērst',
  canvasExitFullView: 'Iziet no pilnā skata',
  webSourceUnread: 'Saite šajā atbildē. Poneva šo lapu nelasīja, tāpēc šeit nav ko rādīt.',
  webSourceOpenOriginal: 'Atvērt oriģinālu',
  toolProgressSettings: 'Maina jūsu iestatījumus…',
  toolProgressAgent: 'Izveido aģentu…',
  toolProgressConnections: 'Meklē savienojuma iespējas…',
  toolProgressResult: 'Sagatavo jūsu rezultātu…',
  toolProgressClarification: 'Sagatavo precizējumu…',
  toolProgressKnowledge: 'Sagatavo ieteikto zināšanu atjauninājumu…',
  toolProgressQuestion: 'Sagatavo jums jautājumu…',
  toolProgressSkill: 'Veidojam jūsu Skill…',
  toolErrorSettings: 'Jūsu iestatījumi netika mainīti.',
  toolErrorAgent: 'Aģentu neizdevās izveidot.',
  toolErrorConnections: 'Savienojuma iespējas neizdevās ielādēt.',
  toolErrorResult: 'Rezultāts netika saglabāts.',
  toolErrorClarification: 'Precizējumu neizdevās sagatavot.',
  toolErrorKnowledge: 'Ieteikto zināšanu atjauninājumu neizdevās sagatavot.',
  toolErrorQuestion: 'Jautājumu neizdevās sagatavot.',
  toolErrorSkill: 'Skill melnrakstu neizdevās saglabāt.',
  toolErrorOpenSettings: 'Atvērt Iestatījumus',
  toolErrorOpenAgents: 'Atvērt Aģentus',
  toolErrorOpenConnections: 'Atvērt Savienojumus',
  toolStepIncomplete: 'Šis solis netika pabeigts.',
  toolEarlierAttemptsFailed:
    'zero:iepriekšējo mēģinājumu neizdevās|one:iepriekšējais mēģinājums neizdevās|other:iepriekšējie mēģinājumi neizdevās',
} satisfies AppCopy;
